import clsx from 'clsx'
import { FC } from 'react'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'

import { TaskModel, TaskPriorityEnum, TaskStatusEnum } from '@models/task'

import { useAuth } from '@modules/auth/contexts/AuthContext'
import { PermissionsControl } from '@modules/permissions'

import { PermissionEnum } from '@/constants/permission'

type Props = {
  task: TaskModel
  onMarkAsDoenClick: (task: TaskModel) => void
}

const StatusColors = {
  [TaskStatusEnum.Todo]: 'danger',
  [TaskStatusEnum.Processing]: 'info',
  [TaskStatusEnum.Done]: 'success',
}

const priorityColors = {
  [TaskPriorityEnum.Extreme]: 'danger',
  [TaskPriorityEnum.High]: 'warning',
  [TaskPriorityEnum.Medium]: 'info',
  [TaskPriorityEnum.Low]: 'success',
}

const TaskBubble: FC<Props> = ({ task, onMarkAsDoenClick }) => {
  const intl = useIntl()
  const { currentUser } = useAuth()

  return (
    <div className="border rounded p-5 mb-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="d-flex gap-2">
          <div className={clsx('badge badge-outline', `badge-${StatusColors[task.status!]}`)}>
            {intl.formatMessage({
              id: `enum.task_status.${task.status!.toLowerCase()}`,
            })}
          </div>

          <div className={clsx('badge badge-outline', `badge-${priorityColors[task.priority!]}`)}>
            {intl.formatMessage({
              id: `enum.task_priority.${task.priority!.toLowerCase()}`,
            })}
          </div>
        </div>
      </div>

      <Link
        to={`/tasks/overview/${task.id}`}
        className="fs-6 fw-medium text-base d-block text-dark text-hover-primary"
      >
        {task.name}
      </Link>

      <div className="mt-1">
        {task.status !== TaskStatusEnum.Done &&
          (task.assigned_user_id === currentUser?.id || task.assigner_user_id === currentUser?.id) && (
            <PermissionsControl allow={[PermissionEnum.TASK_UPDATE]}>
              <span
                className="text-muted text-hover-primary cursor-pointer"
                onClick={() => onMarkAsDoenClick(task)}
              >
                {intl.formatMessage({ id: 'topbar_task.mark_as_done' })}
              </span>
            </PermissionsControl>
          )}
      </div>
    </div>
  )
}

export { TaskBubble }
